import axios from "axios";
import { Message } from "element-ui";
import Cookie from "js-cookie";
import Store from "@/store/index";

const fuwuAxios = axios.create();

fuwuAxios.defaults.timeout = 180000;

fuwuAxios.interceptors.request.use(
  config => {
    const newConfig = { ...config };
    const TOKEN = Cookie.get("token");
    if (TOKEN) {
      newConfig.headers.Authorization = `Bearer ${TOKEN}`;
      newConfig["headers"]["Platform-Id"] = "jiker_fuwu_admin";
    }
    return newConfig;
  },
  error => Promise.reject(error)
);

const handleErrorRequest = error => {
  const { response } = error;
  const status = response ? response.status : 408;
  if (response) {
    const { data } = response;
    const { errors } = data;
    const message = data.message || "服务器发送错误，请稍后再试";
    if (status === 401) {
      Store.dispatch("logout");
    } else if (status === 403) {
      Message.error("没有权限！");
    } else if (status === 419) {
      // 页面过期;
      localStorage.clear();
      sessionStorage.clear();
      Store.dispatch("logout");
    } else if (status === 422 || status === 423 || status === 429) {
      let errorObj = errors ? errors : data;
      if (errorObj.msg) {
        return Message.error(errorObj.msg);
      }
      Object.keys(errorObj).forEach(errorKey => {
        const errorValue = errorObj[errorKey].join("\n");
        Message.error(errorValue);
      });
    } else {
      Message.error(message);
    }
  } else {
    Message.error("网络超时");
  }
};

fuwuAxios.interceptors.response.use(
  res => {
    switch (true) {
      case res.data.code === 2000:
        return res.data.data;
      case res.data.code === 200:
        return res.data.data;
      case res.data.error_code === 0:
        return res.data.data;
      case !!res.data.error_code:
        Message.error({
          dangerouslyUseHTMLString: true,
          message: `<pre>${res.data.msg}</pre>`
        });
        return Promise.reject(res.data);
      case !!res.data.code:
        Message.error(res.data.msg);
        return Promise.reject(res.data);
      default:
        return res.data;
    }
  },
  error => {
    handleErrorRequest(error);
    return Promise.reject(error);
  }
);

export default {
  post(url = "", data = {}, config = {}) {
    return fuwuAxios.post(url, data, config);
  },
  put(url = "", data = {}, config = {}) {
    return fuwuAxios.put(url, data, config);
  },
  get(url = "", params = {}, config = {}) {
    const OPTIONS = Object.assign({ params }, config);
    return fuwuAxios.get(url, OPTIONS);
  },
  delete(url = "", params = {}, config = {}) {
    const OPTIONS = Object.assign({ params }, config);
    return fuwuAxios.delete(url, OPTIONS);
  }
};
